import queryString from 'query-string';
import { useLocation } from '@gatsbyjs/reach-router';
import { getStates, isPaymentAgreed } from '@printdeal/business-logic';

import { SanitizedOrder } from '../../../../../../types/order/Order';
import { Environment } from '../../../../../../helpers/env';
// @ts-expect-error
import { isPayable, areAllLineItemsCancelled } from '../../../../../../helpers/order/Order';

const ReasonsDisabled = {
  ORDER_NUMBER_UNAVAILABLE: 'The orderNumber is unavailable',
  ORDER_UNPAYABLE: 'Order cannot be payed',
  AUTOMATIC_PAYMENT: 'The payment will be done automatically (mandates or on-account)',
  ORDER_CANCELLED: 'The order has been cancelled',
};

const canPayOrderHelper = (order: SanitizedOrder) => {
  const location = useLocation();
  const { authResult } = queryString.parse(location.search);
  const states = getStates(Environment);

  if (!order.orderNumber) {
    return {
      enabled: false,
      reasonDisabled: ReasonsDisabled.ORDER_NUMBER_UNAVAILABLE,
      paymentLink: '',
    };
  }

  if (areAllLineItemsCancelled(order.lineItems, states)) {
    return {
      enabled: false,
      reasonDisabled: ReasonsDisabled.ORDER_CANCELLED,
      paymentLink: '',
    };
  }

  // Why does this method suddenly require a fourth attribute here?
  // It has no default value for authResult, and yet it doesn't break even when only three attributes are given?
  if (!isPayable(order, states, order.lineItems, authResult)) {
    return {
      enabled: false,
      reasonDisabled: ReasonsDisabled.ORDER_UNPAYABLE,
      paymentLink: '',
    };
  }

  return {
    enabled: true,
    isPaymentAgreed: isPaymentAgreed(order),
  };
};

export default canPayOrderHelper;
